import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import BeatLoader from 'react-spinners/BeatLoader';
import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router';
import { Button, TextField, InputAdornment } from '@material-ui/core';

import Prompt from '../Shared/Prompt/Prompt';
import PromptWrapper from '../Shared/Prompt/Wrapper';
import PromptActions from '../Shared/Prompt/Actions';
import Swal from 'sweetalert2'

import { resetPw } from '../../Functions/auth';
import { decodeHTMLEntities } from '../../Functions/utils';

import { toastTimerValue } from '../../Shared/utils';
import '../SweetAlert.css'


export default function Reset() {
  const history = useHistory();
  const { token } = useParams();
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [reset, setReset] = useState({
    token: token,
    password: null,
    passCheck: null
  });


  const handleReset = async (e) => {
    e.preventDefault();

    if (!reset.password || !reset.passCheck) {
      return toast(decodeHTMLEntities(t('reset.errors.incomplete')), {type: 'error'});

      // return Swal.fire({
      //   toast: true,
      //   icon: 'error',
      //   title: t('reset.errors.incomplete'),
      //   animation: true,
      //   position: 'top-right',
      //   showConfirmButton: false,
      //   timer: toastTimerValue,
      //   timerProgressBar: true,
      //   iconColor: 'white',
      //   customClass: {
      //     popup: 'colored-toast',
      //   },
      //   didOpen: (toast) => {
      //     toast.addEventListener('mouseenter', Swal.stopTimer)
      //     toast.addEventListener('mouseleave', Swal.resumeTimer)
      //     toast.addEventListener('click', Swal.close)
      //   }
      // });
    }

    if (reset.password !== reset.passCheck) {
      return toast(decodeHTMLEntities(t('reset.errors.different')), {type: 'error'});

      // return Swal.fire({
      //   toast: true,
      //   icon: 'error',
      //   title: t('reset.errors.different'),
      //   animation: true,
      //   position: 'top-right',
      //   showConfirmButton: false,
      //   timer: toastTimerValue,
      //   timerProgressBar: true,
      //   iconColor: 'white',
      //   customClass: {
      //     popup: 'colored-toast',
      //   },
      //   didOpen: (toast) => {
      //     toast.addEventListener('mouseenter', Swal.stopTimer)
      //     toast.addEventListener('mouseleave', Swal.resumeTimer)
      //     toast.addEventListener('click', Swal.close)
      //   }
      // });
    }
  
    setLoading(true);
    const res = await resetPw(reset);
    setLoading(false);

    if (res && res.success) {
      toast(decodeHTMLEntities(t('reset.success')), {type: 'success'});

      // Swal.fire({
      //   toast: true,
      //   icon: 'success',
      //   title: t('reset.success'),
      //   animation: true,
      //   position: 'top-right',
      //   showConfirmButton: false,
      //   timer: toastTimerValue,
      //   timerProgressBar: true,
      //   iconColor: 'white',
      //   customClass: {
      //     popup: 'colored-toast',
      //   },
      //   didOpen: (toast) => {
      //     toast.addEventListener('mouseenter', Swal.stopTimer)
      //     toast.addEventListener('mouseleave', Swal.resumeTimer)
      //     toast.addEventListener('click', Swal.close)
      //   }
      // });
    }
    else {
      toast(decodeHTMLEntities(t('reset.errors.' + res)), {type: 'error'});

      // Swal.fire({
      //   toast: true,
      //   icon: 'error',
      //   title: t('reset.errors.' + res),
      //   animation: true,
      //   position: 'top-right',
      //   showConfirmButton: false,
      //   timer: toastTimerValue,
      //   timerProgressBar: true,
      //   iconColor: 'white',
      //   customClass: {
      //     popup: 'colored-toast',
      //   },
      //   didOpen: (toast) => {
      //     toast.addEventListener('mouseenter', Swal.stopTimer)
      //     toast.addEventListener('mouseleave', Swal.resumeTimer)
      //     toast.addEventListener('click', Swal.close)
      //   }
      // });
    }

    history.replace(res.success ? '/login' : '/forgot');
  };


  useEffect(() => {
    document.title = t('reset.page');
    // Remove the reset code from the URL bar
    window.history.pushState('', document.title, '/reset');
  }, [t]);


  return (
    <Prompt>
      <form className="prompt__container" style={{height: '90%'}} onSubmit={handleReset}>
        <PromptWrapper>
          <div className="prompt__title">
            <h1>{t('reset.title')}</h1>
          </div>

          <div className="prompt__content" style={{gap: '20px'}}>
            <TextField
              InputProps={{
                startAdornment: <InputAdornment position="start">
                  <span className="material-icons-outlined">lock</span>
                </InputAdornment>
              }}
              type="password"
              variant="outlined"
              label={t('reset.field1')}
              autoComplete="new-password"
              onChange={e => setReset({...reset, password: e.target.value})}
            />

            <TextField
              InputProps={{
                startAdornment: <InputAdornment position="start">
                  <span className="material-icons-outlined">check</span>
                </InputAdornment>
              }}
              type="password"
              variant="outlined"
              autoComplete="off"
              label={t('reset.field2')}
              onChange={e => setReset({...reset, passCheck: e.target.value})}
            />
          </div>
        </PromptWrapper>

        <PromptActions column>
          <Button className="btnPrimary" type="submit" disabled={!reset.password || !reset.passCheck || loading}>
            {loading ? <BeatLoader color="white" css="transform:translateY(4px)"/> : t('reset.button')}
          </Button>
        </PromptActions>
      </form>
    </Prompt>
  );
}
